<template>
	<div class="contentbox">
		<div class="media-add-ep-list">
			<div class="top-search">
				<el-form :inline="true" :model="formInline" ref="formInline" size="small" class="demo-form-inline">
					<!--<el-form-item label="小程序" prop="appid" v-if="!isAgent">-->
					<!--<app-list @getAppId="getAppId" :appId="formInline.appId"></app-list>-->
					<!--</el-form-item>-->
					<el-form-item label="用户ID" prop="id">
						<el-input v-model="formInline.id" placeholder="请输入用户ID" clearable @keyup.enter.native="search"
							@clear="search" style="width: 180px;"></el-input>
					</el-form-item>
					<el-form-item label="昵称" prop="nickName">
						<el-input v-model="formInline.nickName" placeholder="请输入昵称" clearable @keyup.enter.native="search"
							@clear="search" style="width: 180px;"></el-input>
					</el-form-item>
					<!--<el-form-item label="会员类型" prop="openVideoId">-->
					<!--<el-input v-model="formInline.openVideoId" placeholder="请输入会员类型" style="width: 150px;"></el-input>-->
					<!--</el-form-item>-->
					<el-form-item label="投放链接ID" prop="tfId">
						<el-input v-model="formInline.tfId" placeholder="请输入投放链接ID" clearable @keyup.enter.native="search"
							@clear="search" style="width: 180px;"></el-input>
					</el-form-item>
					<el-form-item label="系统类型" prop="mos" style="margin-right: 30px;">
						<el-select v-model="formInline.mos" placeholder="请选择系统类型" clearable @change="search" style="width: 180px;">
							<el-option v-for="item in mosOptions" :key="item.value" :label="item.label"
								:value="item.value"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="广告计划ID" prop="promotionId">
						<el-input v-model="formInline.promotionId" placeholder="请输入广告计划ID" clearable @keyup.enter.native="search"
							@clear="search" style="width: 180px;"></el-input>
					</el-form-item>
					<br />
					<el-form-item label="openId：" prop="openId">
						<el-input v-model="formInline.openId" placeholder="请输入openId" clearable @keyup.enter.native="search"
							@clear="search" style="width: 180px;"></el-input>
					</el-form-item>
					<el-form-item label="时间：">
						<el-date-picker v-model="dataTime" class="pickerData" format="yyyy-MM-dd HH:mm:ss" value-format="yyyy-MM-dd HH:mm:ss"
							type="datetimerange" unlink-panels range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"
							style="margin-right: 10px; width: 400px" clearable @change="search">
						</el-date-picker>
					</el-form-item>
					<el-form-item>
						<el-button type="primary" icon="el-icon-search" @click="search">查询</el-button>
					</el-form-item>
					<el-form-item>
						<el-button icon="el-icon-refresh" @click="resetQuery">重置</el-button>
					</el-form-item>
				</el-form>
			</div>
			<div class="tableTh" v-height>
				<el-table :data="tableData.result" border stripe style="width: 100%" height="100%" class="tableStyle"
					v-loading="loading">
					<el-table-column prop="" label="序号" width="60">
						<template slot-scope="scope">
							<span>{{ (tableData.pageNo - 1) * tableData.pageSize + scope.$index + 1 }}</span>
						</template>
					</el-table-column>
					<el-table-column prop="title" label="用户信息">
						<template slot-scope="scope">
							<div class="td-info">
								<p>用户ID：{{ scope.row.id }}</p>
								<p>昵称：{{ scope.row.nickName }}</p>
								<p>推广平台：{{ scope.row.promotionPlatform }}</p>
								<p>用户系统类型：{{ scope.row.mos }}</p>
							</div>
						</template>
					</el-table-column>
					<el-table-column prop="title" label="账户信息">
						<template slot-scope="scope">
							<div class="td-info">
								<p>会员类型：{{ scope.row.type }}</p>
								<p>金币余额：{{ scope.row.balance }}</p>
								<p>总充值金额：{{ scope.row.money }}</p>
								<p>充值次数：{{ scope.row.times }}</p>
							</div>
						</template>
					</el-table-column>
					<el-table-column prop="title" label="小程序信息">
						<template slot-scope="scope">
							<div class="td-info">
								<p>appid: {{ scope.row.appId }}</p>
								<p>小程序名称: {{ scope.row.appName }}</p>
								<p v-if="platform == 'wx-sv' || platform == 'wx-gg-sv'">wx_openid: {{ scope.row.openId }}</p>
								<p v-else>tt_openid: {{ scope.row.openId }}</p>
							</div>
						</template>
					</el-table-column>
					<el-table-column prop="title" label="投放广告信息">
						<template slot-scope="scope">
							<div class="td-info">
								<p>广告计划ID：{{ scope.row.promotionId }}</p>
								<p>广告项目ID：{{ scope.row.projectId }}</p>
							</div>
						</template>
					</el-table-column>
					<el-table-column prop="title" label="其他信息">
						<template slot-scope="scope">
							<div class="td-info">
								<p>投放链接ID：{{ scope.row.tfId }}</p>
								<p>用户今日ECPM：{{ scope.row.ecpm }}</p>
								<p>用户今日ARPU：{{ scope.row.adIne }}</p>
								<p>用户今日IPU：{{ scope.row.ipu }}</p>
							</div>
						</template>
					</el-table-column>
					<el-table-column prop="strAddTime" label="注册时间" width="160">
					</el-table-column>
					<el-table-column label="操作" width="300">
						<template slot-scope="scope" class="ddd">
							<el-button type="defult" icon="el-icon-warning-outline" size="mini"
								@click="handleLook(scope.row.id)">详情</el-button>
							<el-button v-has="'shortUser:update'" type="primary" icon="el-icon-edit" size="mini"
								@click="handleEdit(scope.row.id)">编辑</el-button>
							<el-popover v-has="'shortUser:delete'" width="160" :ref="scope.row.id" style="margin-left: 10px;">
								<p class="popover-con del">
									<i class="el-icon-question warnning-text"></i>确定删除吗？
								</p>
								<div style="text-align: right; margin: 0">
									<el-button size="mini" @click="$refs[scope.row.id].doClose()">取消</el-button>
									<el-button type="primary" size="mini" @click="handleDelete(scope.row.id)">确定</el-button>
								</div>
								<el-button slot="reference" type="danger" icon="el-icon-delete" size="mini">删除</el-button>
							</el-popover>
						</template>
					</el-table-column>
				</el-table>
				<div class="foot-table" style="text-align:center;">
					<!--<el-pagination @current-change="handleCurrentChange" :page-size="tableData.pageSize"-->
					<!--background :current-page="currentPage" :total="tableData.totalNum">-->
					<!--</el-pagination>-->
					<el-pagination @current-change="handleCurrentChange" @size-change="handleSizeChange"
						:page-sizes="[20, 50, 100, 200, 500]" :page-size="tableData.pageSize" background :current-page="currentPage"
						layout="sizes, prev, pager, next, jumper, ->, total" :total="tableData.totalNum">
					</el-pagination>
				</div>
			</div>
		</div>
		<!--详情-->
		<el-dialog title="详情" :visible.sync="dialogInfoVisible" center width="800px">
			<table class="el-table el-table--border el-table--enable-row-hover mytable" cellspacing="0" cellpadding="0">
				<tbody>
					<tr>
						<td width="200">用户信息</td>
						<td>
							<p>用户ID：{{ rowFrom.id }}</p>
							<p>昵称：{{ rowFrom.nickName }}</p>
							<p>推广平台：{{ rowFrom.promotionPlatform }}</p>
							<p>用户系统类型：{{ rowFrom.mos }}</p>
						</td>
					</tr>
					<tr>
						<td>账户信息</td>
						<td>
							<p>会员类型：{{ rowFrom.type }}</p>
							<p>金币余额：{{ rowFrom.balance }}</p>
							<p>总充值金额：{{ rowFrom.money }}</p>
							<p>充值次数：{{ rowFrom.times }}</p>
						</td>
					</tr>
					<tr>
						<td>小程序信息</td>
						<td>
							<p>appid: {{ rowFrom.appId }}</p>
							<p>小程序名称: {{ rowFrom.appName }}</p>
							<p>tt_openid: {{ rowFrom.openId }}</p>
						</td>
					</tr>
					<tr>
						<td>投放广告信息</td>
						<td>
							<p>广告计划ID：{{ rowFrom.promotionId }}</p>
							<p>广告项目ID：{{ rowFrom.projectId }}</p>
						</td>
					</tr>
					<tr>
						<td>其他信息</td>
						<td>
							<p>投放链接ID：{{ rowFrom.tfId }}</p>
							<p>用户今日ECPM：</p>
							<p>用户今日ARPU：</p>
							<p>用户今日IPU：</p>
						</td>
					</tr>
					<tr>
						<td>注册时间</td>
						<td>{{ rowFrom.strAddTime }}</td>
					</tr>
				</tbody>
			</table>
			<div slot="footer" class="dialog-footer">
				<el-button type="primary" @click="dialogInfoVisible = false">确 定</el-button>
			</div>
		</el-dialog>
		<!--修改弹框-->
		<el-dialog title="编辑" :visible.sync="dialogFormVisible" width="650px">
			<el-form :rules="rules" ref="ruleForm" :model="ruleForm" size="small" label-width="150px" class="input350"
				style="max-height: 480px;overflow: auto; padding-right: 20px;">
				<el-form-item label="用户ID：">
					<el-input type="number" v-model="ruleForm.id" disabled="disabled" placeholder="请输入用户ID"></el-input>
				</el-form-item>
				<el-form-item label="昵称：">
					<el-input v-model="ruleForm.nickName" placeholder="请输入昵称"></el-input>
				</el-form-item>
				<el-form-item label="手机号码：">
					<el-input type="number" v-model="ruleForm.tel" placeholder="请输入手机号"></el-input>
				</el-form-item>
				<el-form-item label="会员类型：" prop="ruleForm">
					<el-select v-model="ruleForm.memberType" placeholder="请选择会员类型" clearable>
						<el-option v-for="item in durationTypeOptions" :key="item.value" :label="item.label"
							:value="item.value"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="会员到期时间：">
					<el-date-picker v-model="ruleForm.memberEndTime" :default-value="ruleForm.memberEndTime" type="datetime"
						placeholder="选择日期时间" @change="changeTime">
					</el-date-picker>
				</el-form-item>
				<el-form-item label="金币余额：" prop="balance">
					<el-input type="number" v-model="ruleForm.balance" placeholder="请输入金币余额"></el-input>
				</el-form-item>
				<el-form-item label="clickid" prop="clickid">
					<el-input v-model="ruleForm.clickid" disabled="disabled" placeholder="请输入clickid"></el-input>
				</el-form-item>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click="dialogFormVisible = false">取 消</el-button>
				<el-button type="primary" @click="editDialogSureBtn('ruleForm')">确 定</el-button>
			</div>
		</el-dialog>
	</div>
</template>
<script>
// import AppList from '@/components/AppList'
import { listUser, details, del, addUser } from "@/api/dysvzk/user/user";
export default {
	// components: {
	//     AppList
	// },
	data() {
		// var validateNum = (rule, value, callback) => {
		//     if (!(/(^[1-9]\d*$)/.test(value))) {
		//         return callback(new Error('数字应为正整数'));
		//     } else {
		//         callback();
		//     }
		// };
		return {
			loading: false,
			platform: localStorage.getItem('platform'),
			dataTime: [],
			formInline: {
				appId: localStorage.getItem('appId'),
				id: '',
				mos: '',
				nickName: '',
				tfId: '',
				promotionId: '',
				registerStartDate: '',
				registerEndDate: '',
				openId: ''
			},
			tableData: {
				pageSize: 20,
				pageNo: 1,
				totalPage: 1,
				totalNum: 0,
				result: [
				]
			},
			currentPage: 1,
			dialogFormVisible: false,
			mosOptions: [{
				value: 'iOS',
				label: 'iOS'
			}, {
				value: 'android',
				label: 'android'
			}],
			durationTypeOptions: [ // 类型
				{
					value: 0,
					label: '充值金币'
				},
				{
					value: 1,
					label: '月度会员'
				},
				{
					value: 4,
					label: '季度会员'
				},
				{
					value: 2,
					label: '年度会员'
				},
				// {
				//     value: -1,
				//     label: '单剧购买(代理商专属)'
				// },
			],
			rowFrom: {},
			dialogInfoVisible: false,
			ruleForm: {
				id: "",
				nickName: "",
				balance: '',
				memberType: '',
				memberEndTime: '',
				tel: ''
			},
			rules: {
			},
			isAgent: false,
		}
	},
	computed: {},
	watch: {
	},
	mounted: function () {
		if (JSON.parse(localStorage.getItem('accountInfo')).bangdingAppId) {
			this.isAgent = true
			this.formInline.appId = JSON.parse(localStorage.getItem('accountInfo')).bangdingAppId
		}
		this.getTableData()
	},
	methods: {
		changeTime(val) {
			console.log(val)
			console.log(this.getTime(val))
			this.ruleForm.memberEndTime = this.getTime(val)
		},
		// 从组件获取appid
		// getAppId(data) {
		//     this.formInline.appId = data
		//     this.getTableData()
		// },
		getCurrentDate() {
			let now = new Date();
			let year = now.getFullYear();
			let month = now.getMonth() + 1;
			let day = now.getDate();
			return year + '-' + month + '-' + day;
		},
		search(val) {
			console.log(val)
			this.currentPage = 1
			this.getTableData()
		},
		resetQuery: function () {
			this.$refs['formInline'].resetFields()
			this.dataTime = []
			this.getTableData()
		},
		getTime(time) {
			var date = new Date(time)
			var y = date.getFullYear()
			var m = date.getMonth() + 1
			m = m < 10 ? '0' + m : m
			var d = date.getDate()
			d = d < 10 ? '0' + d : d
			var h = date.getHours()
			h = h < 10 ? '0' + h : h
			var minute = date.getMinutes()
			minute = minute < 10 ? '0' + minute : minute
			var s = date.getSeconds()
			s = s < 10 ? '0' + s : s
			return y + '-' + m + '-' + d + ' ' + h + ':' + minute + ':' + s
		},
		// pageSize切换
		handleSizeChange(val) {
			this.tableData.pageSize = val
			this.currentPage = 1
			this.getTableData()
		},
		handleCurrentChange(value) {
			this.currentPage = value
			this.getTableData()
		},
		handleLook(id) {
			console.log(id)
			this.dialogInfoVisible = true
			this.getDetails(id)
		},
		// 删除
		handleDelete(id) {
			console.log(id)
			del({
				id: id
			}).then(response => {
				if (response.data.head.flag === 0) {
					this.$message({
						message: '删除成功',
						type: 'success'
					});
					this.$refs[id].doClose()
					this.getTableData()
				} else {
					this.$message.error(response.data.head.desc);
				}
			})
		},
		// 编辑
		handleEdit(id) {
			console.log(id)
			if (this.$refs['ruleForm'] !== undefined) {
				this.$refs['ruleForm'].resetFields()
			}
			this.dialogFormVisible = true
			this.getDetails(id, 'edit')
		},
		// 获取详情
		getDetails(id, text) {
			details({
				id: id,
			}).then(response => {
				if (response.data.head.flag === 0) {
					if (text == 'edit') {
						// this.ruleForm.id = response.data.content.id
						// this.ruleForm.nickName = response.data.content.nickName
						// this.ruleForm.balance = response.data.content.balance
						// this.ruleForm.tel = response.data.content.tel
						this.ruleForm = response.data.content
						console.log(this.ruleForm.memberType)
						// this.ruleForm.memberEndTime = new Date()
					} else {
						this.rowFrom = response.data.content
					}
				} else {
					this.$message.error(response.data.head.desc);
				}
			})
		},
		// 弹框确定
		editDialogSureBtn(formName) {
			console.log(this.ruleForm)
			this.$refs[formName].validate((valid) => {
				if (valid) {
					console.log(this.ruleForm.updateType)
					this.saveTableData()
				} else {
					console.log('error submit!!');
					return false;
				}
			});
		},
		// 保存编辑信息
		saveTableData() {
			console.log(this.ruleForm)
			addUser(this.ruleForm).then(response => {
				if (response.data.head.flag === 0) {
					this.$message({
						message: '提交成功',
						type: 'success'
					});
					this.getTableData()
					this.dialogFormVisible = false
				} else {
					this.$message.error(response.data.head.desc);
				}
			})
		},
		getTableData() {
			let json2 = {
				pageNo: this.currentPage,
				pageSize: this.tableData.pageSize
			};
			this.formInline.registerStartDate = this.dataTime ? this.dataTime[0] : ''
			this.formInline.registerEndDate = this.dataTime ? this.dataTime[1] : ''
			let json1 = this.formInline;
			let paramJson = { ...json1, ...json2 };
			listUser(paramJson).then(response => {
				if (response.data.head.flag === 0) {
					this.tableData = response.data.content
				} else {
					this.$message.error(response.data.head.desc)
				}
			});
		},
	}
}
</script>
